<template>
  <SoForm
    v-if="userQuery.data?.customerId && !customerReferralCode.isFetching"
    class="mt-10 border-t-sm pt-6"
    data-testid="user-referral-form"
    @submit="applyVoucher()"
  >
    <label class="user-edit__inline-input">
      Redeemed Voucher
      <SoButton
        v-if="hasReferralCode"
        type="text"
        class="mt-4 d-block"
        :title="customerReferralCode.data?.code"
        @click="customerDetails"
      />
      <SoTextField
        v-else
        v-model="voucherValue"
        :rules="[rules.required]"
        name="user-redeem-voucher"
        type="text"
      />
    </label>
    <template #actions>
      <div class="mt-8">
        <SoButton
          v-if="!hasReferralCode"
          title="apply voucher"
          type="success"
          submit
          large
          data-testid="apply-voucher-btn"
        />
      </div>
    </template>
  </SoForm>
</template>
<script lang="ts">
  import SoTextField from "@/components/formControls/SoTextField.vue"
  import SoForm from "@/components/formControls/SoForm.vue"
  import rules from "@/validators/rules"
  import { defineComponent } from "vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import { UserService } from "@/services/admin/UserService"
  import { ReferralService } from "@/services/operations/ReferralService"
  import { ReferralMutator } from "@/mutators/referral/ReferralMutator"
  import { useSnackbarStore } from "@/stores/snackbar"
  import { RouteNames } from "@/types/router"
  import { errorHandler, errorReporter } from "@/services/ErrorService"

  export default defineComponent({
    components: {
      SoButton,
      SoTextField,
      SoForm,
    },
    data() {
      return {
        voucherValue: "",
        rules: rules,
        snackbar: useSnackbarStore(),
        userQuery: UserService.getUser(Number(this.$route.params.userId)),
        applyReferralCodeMutation: ReferralMutator.applyReferralCode(),
      }
    },
    computed: {
      customerReferralCode() {
        const customerId = this.userQuery.data?.customerId
        if (!customerId) throw new Error("Customer ID not found")
        return ReferralService.getCustomerReferral(customerId)
      },
      hasReferralCode() {
        return !!this.customerReferralCode.data?.code
      },
    },

    methods: {
      async applyVoucher() {
        try {
          const customerId = this.userQuery.data?.customerId
          if (!customerId) throw new Error("Customer ID not found")

          await this.applyReferralCodeMutation.mutateAsync({
            customerId,
            referralCode: this.voucherValue,
          })
          this.snackbar.addInfo("Voucher applied")
        } catch (error) {
          errorReporter.report(error)
          console.error(error)
          this.snackbar.addError(
            errorHandler.userMessage(error, "Failed to apply voucher"),
          )
        }
      },
      customerDetails() {
        this.$router.push({
          name: RouteNames.AdminReferralCode,
          params: { referralCode: this.customerReferralCode.data?.code },
        })
      },
    },
  })
</script>
